<template>
    <div>
        <div v-if="product.crashingMessage" :class="classes" @click="handleClick">
            <div :class="theme.controlWrap">
                <v-font-icon v-if="!product.isEnable" :class="theme.errorIcon" v-margin.right="2">
                    warning
                </v-font-icon>

                <div v-else v-margin.right="1">
                    <v-radio :value="value" :class="[theme.control, isDisabledClass]" :data="product" />
                </div>

                <v-text :class="product.isEnable && isDisabledClass">
                    <strong>{{ product.name }}.</strong> {{ product.crashingMessage }}
                </v-text>
            </div>
        </div>

        <div v-else :class="classes" @click="handleClick">
            <div v-if="product.isEnable" :class="theme.controlWrap">
                <div v-margin.right="1">
                    <v-radio :value="value" :class="[theme.control, isDisabledClass]" :data="product" />
                </div>
                <v-text :class="isDisabledClass">
                    {{ product.name }}
                </v-text>
                <v-link v-if="product.id !== -1" v-margin.left="1" v-margin.right="1" :class="theme.reportLink"
                    :to="getUrl('reportExample/' + product.id)" target="_blank" @click="handleClick">
                    <v-font-icon small grey>info</v-font-icon>
                </v-link>
            </div>

            <div v-else :class="theme.controlWrap">
                <div v-margin.right="1">
                    <v-radio :value="value" :class="[theme.control, isDisabledClass]" :data="product" />
                </div>
                <v-tooltip text="Продукт будет доступен при прохождении идентификации." position="top">
                    <v-text :class="isDisabledClass">
                        {{ product.name }}
                    </v-text>
                    <v-link v-margin.left="1" v-margin.right="1" :class="theme.reportLink"
                        :to="getUrl('reportExample/' + product.id)" target="_blank" @click="handleClick">
                        <v-font-icon small grey>info</v-font-icon>
                    </v-link>
                </v-tooltip>
            </div>

            <div :class="theme.productCount">
                <v-label orange v-if="product.freeCount" v-margin.right="2" :class="isDisabledClass">
                    Бесплатно {{ product.freeCount }} {{ declOfNum(product.freeCount, ['запрос', 'запроса', 'запросов'])
                    }}
                </v-label>
                <v-text v-if="product.id !== -1" nowrap :class="isDisabledClass">
                    {{ product.availableCount }} шт
                </v-text>
            </div>
        </div>

        <v-separator v-if="addSeparator" />

    </div>
</template>

<script>
import { declOfNum } from '../../../helpers';
import { getUrl } from '../../../router';
import theme from './theme.scss';

export default {
    name: 'request-product',
    props: {
        addSeparator: Boolean,
        tariff: Boolean,
        disabled: Boolean,
        value: {
            type: Object,
            default() {
                return {};
            }
        },
        product: Object,
        theme: {
            type: Object,
            default() {
                return theme;
            }
        }
    },
    methods: {
        declOfNum,
        getUrl,

        handleClick() {
            if (this.disabled) {
                return;
            }
            this.$emit('input', this.product);
        }
    },
    computed: {
        errorClasses() {
            return {
                [this.theme.product]: true,
                [this.theme.isDisabled]: this.disabled,
            }
        },
        isDisabledClass() {
            return this.disabled && this.theme.isDisabled;
        },
        classes() {
            return {
                [this.theme.product]: true,
                [this.theme.isError]: !!this.product.crashingMessage,
            }
        }
    },
}
</script>


// WEBPACK FOOTER //
// RequestProduct.vue?fb7204de